import styled from '@benzinga/themetron';
import { SearchTool } from './SearchBarTool';
import React from 'react';
import { SearchBarProps, SearchBarState } from '../SearchBar';
import { Close } from '@benzinga/themed-icons';

export const CLEAR_TOOL_ID = 'clear' as const;

export class ClearTool implements SearchTool {
  id = CLEAR_TOOL_ID;
  description = 'Clear';
  onClear?: () => void;
  force?: boolean;
  constructor(onClear?: () => void) {
    this.onClear = onClear;
  }
  public getTool(
    _: SearchBarProps,
    searchBarState: SearchBarState,
    _1: React.Dispatch<React.SetStateAction<SearchBarState>>,
  ) {
    return (searchBarState.parsedExpression.length > 1 || this.force) && this.onClear ? (
      <ClearIcon key={this.id} onClick={this.onClear} />
    ) : null;
  }
  public setOnClear(onClear?: () => void) {
    this.onClear = onClear;
  }
  public getOnClear() {
    return this.onClear;
  }
  public forceEnable(force: boolean) {
    return (this.force = force);
  }
}

export const createClearTool = (onClear?: () => void): ClearTool => {
  return new ClearTool(onClear);
};

export function isClearTool(tool: SearchTool): tool is ClearTool {
  return tool.id === CLEAR_TOOL_ID;
}

export const useClearTool = (onClear?: () => void): SearchTool => {
  return React.useMemo(() => createClearTool(onClear), [onClear]);
};

const ClearIcon = styled(Close)`
  fill: ${props => props.theme.colors.foregroundInactive};
  font-size: 24px;
  cursor: pointer;
  margin: 2px;
`;
